<template>
  <a :href="redirect" class="button-submit" target="_blank">
    <slot />
  </a>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';

const STEADY_CLIENT_ID = 'meta[name="steady_client_id"]';
const STEADY_REDIRECT_URI = 'meta[name="steady_redirect_uri"]';
const STEADY_PUBLICATION = 'meta[name="steady_publication"]';
const STEADY_AUTHORIZE_URI = 'https://steadyhq.com/oauth/authorize';
const STEADY_RESPONSE_TYPE = 'code';
const STEADY_SCOPE = 'read';
const STEADY_STATE = 'sanktaudio';

const client_id = computed(() => document.querySelector(STEADY_CLIENT_ID).content);
const redirect_uri = computed(() => document.querySelector(STEADY_REDIRECT_URI).content);
const publication = computed(() => document.querySelector(STEADY_PUBLICATION).content);

const payload = computed(() =>
{
  const result = new Object;
  result['response_type'] = STEADY_RESPONSE_TYPE;
  result['redirect_uri'] = redirect_uri.value;
  result['client_id'] = client_id.value;
  result['scope'] = STEADY_SCOPE;
  result['state'] = STEADY_STATE;
  return result;
});

const redirect = computed(() =>
{
  const target = STEADY_AUTHORIZE_URI;
  const params = payload.value;
  const query = new URLSearchParams(params);
  const result = [target, query.toString()].join('?');
  return result;
});
</script>
